import { z } from 'zod';

/* GET /api/admin/overview */
export const AdminOverviewResponseSchema = z.object({
  activeUsers24h: z.number().int().nonnegative(),
  newSignups24h: z.number().int().nonnegative(),
  activeSpots: z.number().int().nonnegative(),
  openReports: z.number().int().nonnegative(),
  sanctions7d: z.number().int().nonnegative(),
  pendingSpots: z.number().int().nonnegative(),
  openAppeals: z.number().int().nonnegative(),
  /** Circles submitted for review and not yet approved. */
  pendingCircles: z.number().int().nonnegative(),
  /** Nearmirer Pro access requests awaiting a decision. */
  pendingPro: z.number().int().nonnegative(),
});
export type AdminOverviewResponse = z.infer<typeof AdminOverviewResponseSchema>;
